/*@ngInject*/
const FormRegistrationModel = function () {
    let registrations = [];

    this.addRegistration = function (formId, url) {
        let doAdd = false;

        if (!registrations[formId]) {
            registrations[formId] = [];
            doAdd = true;
        }

        if (!doAdd) {
            doAdd = true;
            _.each(registrations[formId], function (registration) {
                if (JSON.stringify(url) === JSON.stringify(registration)) {
                    doAdd = false;
                }
            });
        }

        if (doAdd) {
            registrations[formId].push(url);
        }
    };

    this.removeRegistrations = function (formId) {
        delete registrations[formId];
    };

    this.clearRegistrations = function () {
        registrations = [];
    };

    this.getRegistrations = function (formId) {
        return registrations[formId];
    };
};

angular.module('umFormViewer')
    .service('formRegistrationModel', FormRegistrationModel);
